import type { CareerHubCountry } from 'src/types';

const restrictedCountries: CareerHubCountry[] = ['au', 'hk'];
const appBannerRestrictedCountries: CareerHubCountry[] = [
  'au',
  'nz',
  'th',
  'hk',
];

// TODO: This can be removed once all markets were released
export const useIsRestrictedCountry = (
  countryCode: CareerHubCountry,
): boolean => restrictedCountries.includes(countryCode);

// TODO: This can be removed once all markets were released
export const useAppBannerIsRestrictedCountry = (
  countryCode: CareerHubCountry,
): boolean => appBannerRestrictedCountries.includes(countryCode);
